import URLSearchParamsService from "./URLSearchParamsService";

class EditModeService {
  get editModeActive() {
    return window.location.pathname.includes("wp-admin") && URLSearchParamsService.get("preview") !== "true";
  }
}

export default new EditModeService();
